import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TickerTape from "@/components/landing/TickerTape";
import LiveBoard from "@/components/landing/LiveBoard";
import Chapters from "@/components/landing/Chapters";
import EncryptedFeed from "@/components/landing/EncryptedFeed";
import AccessTiers from "@/components/landing/AccessTiers";
import Footer from "@/components/landing/Footer";
import MacroBoard from "@/components/landing/MacroBoard";
import StocksBoard from "@/components/landing/StocksBoard";
import PaymentSuccess from "@/components/landing/PaymentSuccess";
import PaymentCancel from "@/components/landing/PaymentCancel";
import Admin from "@/components/landing/Admin";
import Markets from "@/components/landing/Markets";
import { TermsPage, PrivacyPage, RiskPage, ContactPage } from "@/components/landing/Legal";
import AiDesk from "@/components/landing/AiDesk";
import Terminal from "@/components/landing/Terminal";
import AureonIntro from "@/components/landing/AureonIntro";
import { useMarkets } from "@/hooks/useMarkets";

function Landing() {
  const { coins, macro, stocks, updatedAt, loading } = useMarkets();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="aureon-landing">
      <AureonIntro />
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <TickerTape coins={coins} />
        <LiveBoard coins={coins} updatedAt={updatedAt} loading={loading} />
        <StocksBoard rows={stocks} />
        <MacroBoard rows={macro} />
        <AiDesk />
        <Chapters />
        <EncryptedFeed />
        <AccessTiers />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/risk" element={<RiskPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/terminal" element={<Terminal />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
